import React, { useMemo } from "react";
import { v4 as uuid } from "uuid";
import { MESSAGE } from "../../message";
import OverviewIcon from "../shared/icon/OverviewIcon";
import ProductIcon from "../shared/icon/ProductIcon";
import UserGroupIcon from "../shared/icon/UserGroupIcon";
import PackageIcon from "../shared/icon/PackageIcon";
import LayoutIcon from "../shared/icon/LayoutIcon";
import HouseIcon from "../shared/icon/HouseIcon";
import { CHECK_ORDER_BULK_PREPARE, CHECK_ORDER_DELIVERY_ALL, CHECK_RETURN_PROD_STATUS, orderStatusFormatted, PREPARE_BULK_TAB, USER_ROLE_TYPE, userType } from "src/constant";
import useAuthGlobal from "src/context/useAuthGlobal";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function useSideBar() {
  const { userMe } = useAuthGlobal();
  const permisisionCheck = useRoleCheck();

  const sidebar = [
    {
      id: uuid(),
      title: MESSAGE.OVERVIEW,
      icon: <LayoutIcon color="var(--white)" />,
      path: "/home",
    },
    {
      id: uuid(),
      title: MESSAGE.WAREHOUSE,
      icon: <HouseIcon color="var(--white)" />,
      path: "/warehouse-management",
      child: [
        {
          id: uuid(),
          title: "Nhập lô sản phẩm",
          path: "/warehouse-management/batch?tab=batch",
          name: "batch",
          display: permisisionCheck([PERMISSIONS.VIEW_BATCH_ALL, PERMISSIONS.VIEW_BATCH_OWN]),
        },
        {
          id: uuid(),
          title: "Xuất/ Chuyển kho",
          path: "/warehouse-management?tab=history-out",
          name: "history-out",
          display: permisisionCheck([PERMISSIONS.VIEW_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.VIEW_WAREHOUSETRANSFEREXPORT_OWN]),
        },
        {
          id: uuid(),
          title: "Nhập kho",
          path: "/warehouse-management/inventory-in?tab=history-in",
          name: "history-in",
          display: permisisionCheck([PERMISSIONS.VIEW_WAREHOUSETRANSFERIMPORT_OWN, PERMISSIONS.VIEW_WAREHOUSETRANSFERIMPORT_ALL]),
        },
        {
          id: uuid(),
          title: "Tồn kho",
          path: "/warehouse-management/inventory?tab=inventory",
          name: "inventory",
          display: permisisionCheck([PERMISSIONS.VIEW_INVENTORY_ALL, PERMISSIONS.VIEW_INVENTORY_OWN, PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]),
        },
        {
          id: uuid(),
          title: "Cân bằng kho",
          path: "/warehouse-management?tab=inventory-balance",
          name: "inventory-balance",
          disabled: true,
        },
      ],
    },
    {
      id: uuid(),
      title: "Quản lý sản phẩm",
      icon: <ProductIcon color="var(--white)" />,
      path: "/product",
      child: [
        {
          id: uuid(),
          title: "Sản phẩm/ Hàng hoá",
          path: "/product?tab=product&order=1",
          name: "product",
          display: permisisionCheck([PERMISSIONS.VIEW_PRODUCT]),
        },
        {
          id: uuid(),
          title: "Thương hiệu",
          path: "/product?tab=brands",
          name: "brands",
          display: permisisionCheck([PERMISSIONS.VIEW_BRAND]),
        },
        {
          id: uuid(),
          title: "Nhà sản xuất",
          path: "/product?tab=manufacturer",
          name: "manufacturer",
          display: permisisionCheck([PERMISSIONS.VIEW_MANUFACTURER_ALL, PERMISSIONS.VIEW_MANUFACTURER_OWN]),
        },
      ],
    },
    {
      id: uuid(),
      title: "Quản lý tài chính",
      icon: <OverviewIcon color="var(--white)" />,
      path: "/debt",
      child: [
        {
          id: uuid(),
          title: "Công nợ kho",
          path: "/debt?tab=debt&subTab=internal-import",
          name: "debt",
        },
        {
          id: uuid(),
          title: "Công nợ sales",
          path: "/debt?tab=debt-sales",
          name: "debt-sales",
        },
        {
          id: uuid(),
          title: "Xuất báo cáo",
          path: "/debt?tab=report",
          name: "report",
        },
        {
          id: uuid(),
          title: "Thiết lập thông tin thanh toán",
          path: "/bank-info?tab=bank-info",
          name: "bank-info",
        },
      ],
    },
    {
      id: uuid(),
      title: "Quản lý đơn hàng",
      icon: <PackageIcon color="var(--white)" />,
      path: "/orders",
      child: [
        {
          id: uuid(),
          title: "Tất cả đơn hàng",
          path: "/orders?tab=all",
          name: "all",
          display: permisisionCheck([PERMISSIONS.VIEW_ORDER_ALL, PERMISSIONS.VIEW_ORDER_OWN]),
        },
        {
          id: uuid(),
          title: "Soạn hàng hàng loạt",
          path: `/orders?tab=${CHECK_ORDER_BULK_PREPARE.prepareBulk}&child=${PREPARE_BULK_TAB.quickPrepare}`,
          name: CHECK_ORDER_BULK_PREPARE.prepareBulk,
          display: permisisionCheck([PERMISSIONS.VIEW_ORDER_ALL, PERMISSIONS.VIEW_ORDER_OWN]),
        },
        {
          id: uuid(),
          title: "Trả hàng hàng loạt",
          path: `/orders?tab=${CHECK_ORDER_DELIVERY_ALL.BulkReturnProcessing}`,
          name: CHECK_ORDER_DELIVERY_ALL.BulkReturnProcessing,
          display: permisisionCheck([PERMISSIONS.VIEW_ORDER_ALL, PERMISSIONS.VIEW_ORDER_OWN]),
        },
        {
          id: uuid(),
          title: "Đơn hủy",
          path: `/orders?tab=${orderStatusFormatted.Canceled}`,
          name: CHECK_ORDER_DELIVERY_ALL.Canceled,
          display: permisisionCheck([PERMISSIONS.VIEW_ORDER_ALL, PERMISSIONS.VIEW_ORDER_OWN]),
        },
        {
          id: uuid(),
          title: "Giao không thành công",
          path: `/orders?tab=${orderStatusFormatted.DeliveredFailed}`,
          name: CHECK_ORDER_DELIVERY_ALL.DeliveredFailed,
          display: permisisionCheck([PERMISSIONS.VIEW_ORDER_ALL, PERMISSIONS.VIEW_ORDER_OWN]),
        },
      ],
    },
    // {
    //   id: uuid(),
    //   title: "Quản lý Tài chính",
    //   icon: <OverviewIcon color="var(--white)" />,
    //   path: "/finance",
    //   child: [
    //     {
    //       id: uuid(),
    //       title: "Tất cả Công nợ",
    //       path: "/finance?page=all&tab=Paid",
    //       name: "Paid",
    //     },
    //     {
    //       id: uuid(),
    //       title: "Báo cáo công nợ",
    //       path: "/finance?page=report&tab=unfinished",
    //       name: "unfinished",
    //     },
    //     {
    //       id: uuid(),
    //       title: "Báo cáo doanh thu",
    //       path: "/finance?page=profit&tab=profit",
    //       name: "profit",
    //     },
    //   ],
    // },
    {
      id: uuid(),
      title: "Quản lý người dùng",
      icon: <UserGroupIcon color="var(--white)" />,
      path: "/user",
      child: [
        {
          id: uuid(),
          title: "Kênh TMĐT tích hợp",
          path: "/user?tab=channel",
          name: "channel",
          disabled: true,
        },
        {
          id: uuid(),
          title: "Khách hàng",
          path: "/user?tab=AllCustomer",
          name: "AllCustomer",
          display: permisisionCheck([PERMISSIONS.VIEW_CUSTOMER]),
        },
        {
          id: uuid(),
          title: "Nhân viên",
          path: "/user?tab=SalesChannel",
          name: "SalesChannel",
          disabled: userMe?.type === userType.sales || userMe?.role?.code === USER_ROLE_TYPE.SALES,
          display: permisisionCheck([PERMISSIONS.VIEW_SALES_OWN, PERMISSIONS.VIEW_SALES_ALL]),
        },
      ],
    },
    {
      id: uuid(),
      title: "Thiết lập Hệ thống",
      icon: <OverviewIcon color="var(--white)" />,
      path: "/setting",
      child: [
        {
          id: uuid(),
          title: "DS Nhà cung cấp",
          path: "/setting/providers?tab=providers",
          name: "providers",
          disabled: userMe?.warehouse?.type === CHECK_RETURN_PROD_STATUS.normal,
          display: permisisionCheck([PERMISSIONS.VIEW_PROVIDER]),
        },
        {
          id: uuid(),
          title: "DS Kho hàng",
          path: "/setting/warehouse?tab=warehouse",
          name: "warehouse",
          display: permisisionCheck([PERMISSIONS.VIEW_WAREHOUSE_ALL, PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]),
        },
        {
          id: uuid(),
          title: "Đơn vị vận chuyển",
          path: "/setting/transportation-provider?tab=transportation-provider",
          name: "transportation-provider",
          display: permisisionCheck([PERMISSIONS.VIEW_SHIPPINGPROVIDER_ALL, PERMISSIONS.VIEW_SHIPPINGPROVIDER_OWN]),
        },
        {
          id: uuid(),
          title: "Cài đặt chung",
          path: "/setting?tab=setting",
          name: "setting",
          disabled: true,
        },
      ],
    },
  ];
  return sidebar;
}
